import { URLS } from 'api/constants';
import {
  IBlogPost,
  ICasino,
  IComplaint,
  IProvider,
  ISlot,
  IStreamer,
} from 'constants/types';
import { useQuery } from 'hooks/useQuery';
import { apiGet } from 'lib/api/client';
import { HookQueryOptions, queryKey } from './shared';

export type SearchType =
  | 'casinos'
  | 'slots'
  | 'providers'
  | 'complaints'
  | 'blogs'
  | 'streamers';

export type SearchRequest = {
  searchQuery: string;
  // Comma-separated SearchType list; all types when omitted
  type?: string;
  // Page size per type (API default 20, max 50)
  limit?: number;
  offset?: number;
};

export type SearchResults = {
  slots: ISlot[];
  casinos: ICasino[];
  complaints: IComplaint[];
  blogs: IBlogPost[];
  streamers: IStreamer[];
  providers: IProvider[];
};

export type SearchResponse = {
  results: SearchResults;
  // Total matches per type, regardless of limit/offset
  counts: Record<SearchType, number>;
  count: number;
};

export const fetchSearch = (payload: SearchRequest) =>
  apiGet<SearchResponse>(URLS.SEARCH, {
    searchQuery: payload.searchQuery,
    type: payload.type,
    limit: payload.limit,
    offset: payload.offset,
  });

export const useSearchQuery = (
  payload: SearchRequest,
  options?: HookQueryOptions
) =>
  useQuery(
    queryKey('search.all', payload),
    () => fetchSearch({ ...payload, searchQuery: payload?.searchQuery ?? '' }),
    { skip: options?.skip || !payload?.searchQuery }
  );

export const useSearchStreamersQuery = (
  payload: SearchRequest,
  options?: HookQueryOptions
) =>
  useQuery(
    queryKey('search.streamers', payload),
    () =>
      apiGet<SearchResponse>(URLS.SEARCH_STREAMERS, {
        searchQuery: payload?.searchQuery ?? '',
        limit: payload?.limit,
      }),
    { skip: options?.skip || !payload?.searchQuery }
  );
